<template lang="pug">
.main-wrapper
    .nav-wrapper
        Navigation
    VGrid.container.project-content.fade-in(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax1")
                    img.main-image.large(
                        src="@/assets/images/blink/blink-poster.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square(data-depth="0.15")
                    .filled-squares(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Blink
                        .title-section-description
                            .company By Influx.Studio
                            .description Trapped inside an old dusty book hidden inside the <br/>bookshelf lies a beingfar more capable than those roaming this earth.<br/> This being binds itself to the reader, preying on their fear.
                    .title-section-content
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Film, Sound, Video Editing
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#planning") 02 Planning
                            .menu-item
                                a.label(data-link="#trailer") 03 Trailer
                            .menu-item
                                a.label(data-link="#film") 04 Film
                            .menu-item
                                a.label(data-link="#solutions") 05 Solutions
                            .menu-item
                                a.label(data-link="#camera") 06 Technologies
            .title-section-gridlines

    .light
        VGrid#overview.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Overview
            VRow.overview-section-spacing
                VCol(variant="xs-10")
                    VRow.space-around
                        VCol(variant="xs-6")
                            .general-item 
                                span.title The Concept
                                p.description As ameteur filmmakers we went above and beyond to create a shortfilm that is captivating and invokes a sense of fear in the viewer. Through meticulously planned visual aesthetics and sound design, the viewer is drawn into the film and always at the edge of their seats.
                VCol(variant="xs-2") 
                    span.general-section-share Share This
                    .general-section-social-share
                        VRow
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.facebook.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/facebook.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://twitter.com/?lang=en",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/twitter.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.instagram.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/insta.svg") 
                    .general-section-project-scope
                        span.scope Scope of Project
                        .scope-item Film

    .cream
        VGrid#planning.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Planning
            VRow.overview-section-spacing
                VCol(variant="xs-6")
                    .general-item 
                        span.title Visual Aesthetic
                        p.description Darkness in horror movies are a pivotal part to creating tension. Most horror movies, however, struggle to create convincing darkness while maintaining clarity on the subjects. For our shortfilm, we want to emphasize the darkness causes by power outages, with the only sources of light being candlelight. This allows us to use the short candlelight's range to our advantage to place emphasis on the areas we want the audience to focus on.
                VCol(variant="xs-6") 
                    .general-item 
                        span.title Location
                        p.description To match the film's aesthetics we wanted to find an old Victorian house that would create the desired atmosphere we were looking for.
            VRow
                VCol.image-carousel(variant="xs-12")
                    //- img.carousel-item(src="@/assets/images/swift-mockups/strategy.jpg", data-depth="0.3")
                    slider(ref="slider", :options="options")
                        slideritem(
                            v-for="(item, index) in carouselList",
                            v-bind:key="item"
                        ) 
                            img.carousel-item(
                                :src="item.src",
                                data-depth="0.3"
                            )

    .light-grey
        VGrid#trailer.container.mockups-trigger(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Blink trailer
            VRow.side-scroll
                VCol(variant="xs-12")
                    video.promo-video(
                        src="@/assets/videos/blink-trailer.mp4",
                        controls
                    )

    .dark
        VGrid#film.container.mockups-trigger(variant="container")
            VRow
                VCol.section-title.line.light-text(variant="xs-12") Blink - Horror Short Film
            VRow.side-scroll
                VCol(variant="xs-12")
                    video.promo-video(
                        src="@/assets/videos/blink-final.mp4",
                        controls
                    )

    .light
        VGrid#solutions.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technical Solutions
            VRow
                VCol(variant="xs-6") 
                    .general-item
                        span.title Problems
                        ol 
                            li.list-item 1. Limited budget
                            li.list-item 2. A short timeframe to shoot and edit the film.
                            li.list-item 3. Sound equipment did not record the first day's audio.
                VCol(variant="xs-6") 
                    .general-item
                        span.title Solutions
                        ol 
                            li.list-item 1. We luckily had a good quality camera and borrowed the necessary camera and sound equipment to shoot in a low-light environment.
                            li.list-item 2. Our team managed to solve this by talking to people from industry to learn how to optimise shot lists through movement orders.
                            li.list-item 3. We lost almost all of the first day of shooting's audio and had to extend the shoot and reshoot most of the scenes for that day. Lesson learned.

    .light
        VGrid#camera.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technologies Used
            VRow.align-center
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/premiere.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/aftereffects.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/audition.png",
                        data-depth="0.3"
                    )

    .cream
        VGrid.container(variant="container")
            VRow.contact-us
                VCol(variant="xs-12")
                    h1.align-center.contact-description Want to work with us?
                    .align-center.scroll-down
                        router-link.contact-button.primary-button(
                            :to="{ name: 'home', query: { c: true } }",
                            data-cursor-shrink
                        ) Start A Project
                VCol(variant="xs-12")
                    .icon-scroll 
                    p.scroll-text Next Project: Dawn

    VGrid.container.project-content(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax2")
                    img.main-image.large(
                        src="@/assets/images/dawn/dawn.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern-2(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square-2(data-depth="0.15")
                    .filled-squares-2(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Dawn
                        .title-section-description
                            .company By Influx.Studio
                            .description Dawn is a first person puzzle game set in a sci-fi environment.<br/> It combines puzzle mechanics along with the concept <br/> of colour to interact with the objects around you <br/> to complete the puzzle.
                    .title-section-content-2
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Game Development, Audio, Lighting, Animation
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#promotional") 02 Promo
                            .menu-item
                                a.label(data-link="#solutions") 03 Solutions
                            .menu-item
                                a.label(data-link="#technologies") 04 Technologies
            .title-section-gridlines

    .static-elements
        .static-wrapper-inner.navigation-container
            //- Navigation.staticnav
        .static-wrapper-inner.static-footer
            p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";
import ScrollMagic from "scrollmagic";
import $ from "jquery";

import Vue from "vue";
import FlexboxgridVue from "@vivid-web/flexboxgrid-vue";
import { slider, slideritem } from "vue-concise-slider";

/* $(window).scroll(function() {
   if ($(window).scrollTop() + $(window).height() == $(document).height()) window.location = "swift";
}); */

Vue.use(FlexboxgridVue);

export default {
    name: "Single-Work",
    data() {
        return {
            carouselList: [
                {
                    src: require("@/assets/images/blink/aesthetic.jpg"),
                },
                {
                    src: require("@/assets/images/blink/location.jpg"),
                },
                {
                    src: require("@/assets/images/blink/monster.jpg"),
                },
                {
                    src: require("@/assets/images/blink/book.jpg"),
                },
            ],
            //Slider configuration [obj]
            options: {
                currentPage: 0,
                loop: true,
                itemAnimation: true,
                centeredSlides: true,
                loopedSlides: 2,
                slidesToScroll: 1,
            },
        };
    },
    computed: {
        workname() {
            return this.$route.params.workname;
        },
    },
    components: {
        Navigation,
        slider,
        slideritem,
    },
    methods: {},
    metaInfo() {
        return {
            title: this.workname,
        };
    },
    mounted() {
        function scrollToElement(selector) {
            $("html, body")
                .stop(true, false)
                .animate(
                    {
                        scrollTop: $(selector).offset().top,
                    },
                    500,
                    "swing"
                );
        }

        $(document).on("click", ".menu-item a", function (e) {
            e.preventDefault();
            scrollToElement($(this).attr("data-link"));
            return false;
        });

        window.scrollTo(0, 0);

        new Parallax(this.$refs.parallax1, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        new Parallax(this.$refs.parallax2, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        let self = this;

        $(window).scroll(function () {
            if (
                $(window).scrollTop() + $(window).height() ==
                    $(document).height() &&
                self.$route.name == "blink"
            )
                self.$router.push({ name: "dawn" });
        });

        var controller = new ScrollMagic.Controller();

        var revealElements = document.getElementsByClassName("carousel-scroll");
        for (var i = 0; i < revealElements.length; i++) {
            // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
                offset: 100, // start a little later
                triggerHook: 0.9,
                duration: "90%",
            })
                .setClassToggle(revealElements[i], "visible") // add class toggle
                .addTo(controller);
        }

        new ScrollMagic.Scene({
            triggerElement: "#light",
            offset: 200,
            duration: 3000,
        })
            .setPin(".image-scroll-section")
            .setPin(".light-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#dark",
            offset: 200,
            duration: 3000,
        })
            .setPin(".image-scroll-section")
            .setPin(".dark-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".scroll-down",
            offset: 0,
        })
            .on("start", function () {
                if (this.$route.name != "home" || this.$route.name != "works")
                    $("html, body").animate(
                        { scrollTop: $(document).height() },
                        2000
                    );
            })
            .addTo(controller);

        EventBus.$emit("rescan-cursor");
    },
    beforeDestroy() {
        $(window).off("scroll");
    },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    //
}
.nav-wrapper {
    margin-top: $body-padding-desktop-y;
    padding: 0 $body-padding-desktop-x;
}

// Title Layout Section
.title-section {
    position: relative;
    background-color: $cl-cream;
}

.title-section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: 0;
}

.title-section-wrapper {
    width: 100%;
    height: 100%;
    background-color: $cl-cream;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    position: relative;
    z-index: 2;

    .title-section-inner-wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .title-section-title {
            color: $cl-grey;
            font-size: 7rem;
            line-height: 1.2em;
        }

        .title-section-image {
            margin-right: 8rem;
            position: relative;

            .main-image {
                max-width: 30rem;
                position: relative;
                z-index: 3;

                &.large {
                    max-width: 40rem;
                }
            }

            .dot-pattern {
                position: absolute;
                width: 70%;
                margin-left: -8rem;
                margin-top: 3rem;
                z-index: 1;
            }

            .outline-square {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -5rem;
                margin-left: 5rem;
                z-index: 1;
            }

            .filled-squares {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 9.6rem;
                    height: 9.6rem;
                    bottom: -2.4rem;
                    right: -2.4rem;
                    background-color: $cl-red;
                }

                &::after {
                    content: "";
                    position: absolute;
                    width: 16rem;
                    height: 16rem;
                    top: -3.6%;
                    left: -3.6rem;
                    border: 1px solid $cl-grey;
                }
            }

            .dot-pattern-2 {
                position: absolute;
                width: 70%;
                margin-left: 9.5rem;
                margin-top: 1.5rem;
                z-index: 1;
            }

            .outline-square-2 {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -4rem;
                margin-left: -5rem;
                z-index: 1;
            }

            .filled-squares-2 {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::after {
                    content: "";
                    position: absolute;
                    width: 8rem;
                    height: 8rem;
                    bottom: -2.5rem;
                    right: 38rem;
                    background-color: $cl-red;
                }
            }
        }

        .title-section-content-container {
            margin-top: 4.8rem;

            .project-information {
                display: flex;
                flex-direction: row;
            }

            .title-section-content {
                margin-left: 5rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-content-2 {
                margin-left: 5rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-description {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-left: 14rem;
                white-space: nowrap;

                .company {
                    color: $cl-red;
                    font-weight: 600;
                    font-size: 1.4rem;
                }

                .description {
                    color: $cl-grey;
                    font-weight: 500;
                    font-size: 1.4rem;
                    margin-bottom: 1.8rem;
                }
            }
        }
    }
}

.light {
    background-color: white;
    position: relative;
    width: 100%;
}

.light-grey {
    background-color: #f6f6f6;
    position: relative;
    width: 100%;
}

.cream {
    background-color: $cl-cream;
    position: relative;
    width: 100%;
}

.dark {
    background-color: $cl-grey;
    position: relative;
    width: 100%;
}

.container {
    @media (min-width: 1200px) and (max-width: 1599px) {
        max-width: 80%;
    }

    @media (min-width: 1600px) {
        max-width: 75%;
    }

    &.project-content {
        height: 90vh;

        &.fade-in {
            animation: fadeIn ease 2s;
        }

        @keyframes fadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }

    &.project-change {
        height: 100vh;
    }

    position: relative;

    .section-title {
        color: $cl-grey;
        font-size: 3rem;
        font-weight: 400;
        font-family: "Poppins", Helvetica, sans-serif;
        margin-top: 6rem;

        &.line {
            position: relative;
            &::after {
                bottom: 0;
                height: 3px;
                background-color: $cl-red;
                left: 0;
                width: 5rem;
                content: "";
                position: absolute;
            }
        }

        &.light-text {
            color: white;
        }
    }

    .align-center {
        display: flex;
        justify-content: center;
        margin-bottom: 5rem;
        margin-top: 1.5rem;

        .percentage {
            font-size: 4rem;
            color: $cl-red;
        }

        .results-description {
            font-size: 1.5rem;
            font-weight: 500;
        }
    }

    .icon-scroll,
    .icon-scroll:before {
        position: absolute;
        left: 50%;
        z-index: 100;
    }

    .scroll-text {
        font-size: 1.6rem;
        font-weight: 500;
        position: absolute;
        left: 52%;
        margin-top: 1rem;
        opacity: 0.7;
        margin-left: 1rem;
        z-index: 100;
    }

    .icon-scroll {
        width: 40px;
        height: 70px;
        margin-left: -20px;
        top: 100%;
        margin-top: -35px;
        box-shadow: inset 0 0 0 1px $cl-grey;
        border-radius: 25px;
    }

    .icon-scroll:before {
        content: "";
        width: 8px;
        height: 8px;
        background: $cl-grey;
        margin-left: -4px;
        top: 8px;
        border-radius: 4px;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-name: scroll;
    }

    @keyframes scroll {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(46px);
        }
    }

    .contact-us {
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
        margin-top: 1.5rem;

        .contact-description {
            font-size: 4rem;
            font-weight: 600;
            margin-top: 4rem;
            margin-bottom: 4rem;
        }

        .contact-button {
            background-color: $cl-cream;
            margin-top: 0;

            &:hover {
                background-color: $cl-red;
            }
        }

        &.align-center {
            display: flex;
            justify-content: center;
        }
    }

    .overview-section-spacing {
        margin-top: 1.5rem;
        margin-bottom: 4rem;
    }

    .image-carousel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10rem;

        .carousel-item {
            max-width: 80rem;
            min-width: 80rem;
            max-height: 50rem;
            min-height: 50rem;
            object-fit: fit;
        }
    }

    .side-scroll {
        margin-top: 3rem;
        margin-bottom: 6rem;

        .carousel {
            max-width: 28rem;
            max-height: 50rem;
            position: relative;
            z-index: 3;
            margin-right: 5px;

            &.carousel-scroll {
                opacity: 0;
                transform: translateX(-40px);
                transition: all 0.6s ease-out;

                &.visible {
                    opacity: 1;
                    transform: none;
                }
            }
        }
    }

    .slogan-section {
        display: flex;
        justify-content: center;
        text-align: center;

        .brand-slogan {
            font-weight: 600;
            font-size: 6rem;

            .slogan-outline {
                border: 3px solid $cl-red;
                padding-right: 2rem;
                padding-left: 2rem;
                transition: background-color 1s;

                /* &:hover {
                    color: white;
                    background-color: $cl-grey;
                } */
            }
        }
    }

    .image-scroll-section {
        display: flex;
        flex-direction: column;
        margin-top: 8rem;
        margin-bottom: 5rem;

        .image-section {
            position: relative;
            margin-bottom: 2rem;

            .left-image {
                position: relative;
                height: 50rem;
            }

            .right-image {
                position: relative;
                left: 30rem;
                height: 50rem;
            }

            .figure-text-left {
                font-size: 1.3rem;
                font-weight: 800;
                margin-left: 1rem;

                &.light-text {
                    color: white;
                }
            }

            .figure-text-right {
                font-size: 1.3rem;
                font-weight: 800;
                text-align: center;
                margin-left: 1rem;

                &.light-text {
                    color: white;
                }
            }
        }

        .laptop-image-section {
            position: relative;
            margin-bottom: 2rem;

            .image {
                position: relative;
            }
        }
    }

    .section-description {
        color: $cl-grey;
        font-weight: 500;
        font-size: 1.5rem;
        margin-top: 0rem;
        margin-bottom: 2rem;
    }

    .general-item {
        .title {
            color: $cl-grey;
            font-weight: 600;
            font-size: 2rem;
            font-family: "Poppins", Helvetica, sans-serif;

            &.light-text {
                color: white;
            }
        }

        .description {
            color: $cl-grey;
            font-weight: 500;
            font-size: 1.5rem;
            margin-top: 1rem;
            margin-bottom: 2rem;

            &.light-text {
                color: white;
            }
        }

        ol {
            line-height: 1.8em;
            margin-top: 1.5rem;
        }

        ol > li.list-item {
            font-weight: 500;
            font-size: 1.5rem;
        }
    }

    .general-section-share {
        font-weight: 700;
        font-size: 1.3rem;
    }

    .general-section-social-share {
        display: flex;
        flex-direction: row;
        margin-top: 1rem;

        .contact-info-social {
            &:hover {
                img {
                    opacity: 1;
                }
            }
            img {
                width: 2.2rem;
                height: 2.2rem;
                opacity: 0.75;
                transition: opacity 200ms ease-in-out;
            }

            &:not(:last-child) {
                margin-right: 1rem;
            }
        }
    }

    .general-section-project-scope {
        margin-top: 5rem;
        .scope {
            font-weight: 700;
            font-size: 1.4rem;
        }
        .scope-item {
            font-weight: 500;
            font-size: 1.3rem;
        }
    }

    .website-link {
        font-weight: 700;
        font-size: 1.4rem;
        color: $cl-red;
        margin-top: 5rem;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $cl-grey;
        }
    }

    .technology-img {
        filter: grayscale(100%);
        width: 20rem;
        height: 7rem;
        object-fit: contain;

        &:hover {
            filter: grayscale(0%);
        }
    }
    .slider-item {
        transform: scale(0.8);
        transition-timing-function: ease;
        transition-duration: 300ms;
    }
    .slider-item.slider-active {
        transform: scale(1);
        z-index: 999;
    }
    .slider-item.slider-active-copy {
        transform: scale(1);
        z-index: 999;
    }
}

.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}
</style>